import React, { useState, useRef, useEffect, useCallback } from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const noimg = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`

const Thumb = ({ src, alt='', width=144, height=144, isAdult = false }) => {
    const [View, setView] = useState(false)
    const [imgSrc, setImgSrc] = useState(src)
    const [error, setError] = useState(false)
    const [load, setLoad] = useState(false)

    const target = useRef(null)

    const imgError = () => {
        setError(true)
        setImgSrc(noimg)
    }

    const imgLoad = () => {
        setLoad(true)
    }

    const scroll = useCallback(() => {
        const elTop = target.current?.getBoundingClientRect().top || 0
        const windowHeight = window.innerHeight
        if (elTop - windowHeight < 0) {
            setView(true)
            window.removeEventListener('scroll', scroll)
        }
    }, [target])

    useEffect(() => {
        window.addEventListener('scroll', scroll)
        return () => window.removeEventListener('scroll', scroll)
    }, [scroll])

    useEffect(() => {
        setTimeout(() => {scroll()}, 50)
    }, [scroll])

    // src변경시 img src 재지정
    useEffect(() => {
        setImgSrc(src)
    }, [src])


    return (
        <Style load={load} width={width} height={height} ref={target}>
            {View &&
                (isAdult ? (
                    <img
                        src={`${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_adult.jpg`}
                        onLoad={imgLoad}
                        className={`${load ? 'showImg' : ''}`}
                        alt="성인용 이미지"
                    />
                ) : !error ? (
                    <img
                        src={imgSrc}
                        alt={alt}
                        onError={imgError}
                        onLoad={imgLoad}
                        className={`${load ? 'showImg' : ''}`}
                    />
                ) : (
                    <img src={imgSrc} alt={alt} className="noImg" />
                ))}
        </Style>
    )
}

Thumb.propTypes = {
    src: PropTypes.string
}

const fadeOn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`

const Style = styled.div`
    width: ${props => props.width}px;
    height: ${props => props.height}px;
    overflow: hidden;

    & > img {
        display: ${props => props.load ? 'block' : 'none'};
        max-width: 100%;
        height: auto;
        -webkit-user-drag: none;

        &.showImg {
            opacity: 0;
            animation: ${fadeOn} .25s forwards;
        }
        &.noImg {
            opacity: 0;
            animation: ${fadeOn} .25s forwards;
            display: block
        }
    }
`

export default Thumb



// WEBPACK FOOTER //
// ./src/estimate_list/components/layout/thumb.js